<template lang="pug">
.tag-input-wrapper
  .input-inner
    aiq-tag.tag-pill(
      v-for="(tag, index) in tags"
      :key="index"
      :item="tag"
      closable
      type="primary"
      @close="removeTag(index)"
    ) {{ tag }}

    aiq-input.real-input(
      v-model="input"
      :max-length="maxLength"
      :min-length="minLength"
      :disabled="disabled"
      :readonly="readonly"
      @keydown.enter.prevent="createTag"
      @keydown.backspace="handleBackspace"
      :placeholder="placeholder"
    )
</template>

<script>
export default {
  name: 'CustomTagInput',
  props: {
    tagValue: {
      type: Array,
      default: () => [],
    },
    maxLength: {
      type: Number,
      default: 250,
    },
    minLength: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['input', 'update-tag'],
  watch: {
    tagValue: {
      handler(val) {
        this.tags = [...val];
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      input: '',
      tags: [],
    };
  },
  methods: {
    createTag() {
      const value = this.input.trim();

      if (!value) return;
      this.$emit('input', value);
      this.input = '';
    },

    removeTag(index) {
      this.tags.splice(index, 1);
      this.$emit('update-tag', this.tags);
    },

    handleBackspace() {
      if (!this.input && this.tags.length) {
        this.tags.pop();
        this.$emit('update-tag', this.tags);
      }
    },
  },
};
</script>

<style scoped>
.tag-input-wrapper {
  width: 100%;
  padding-top:5px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  cursor: text;
}

.input-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}

.tag-pill {
  margin-right: 6px;
  margin-bottom: 4px;
}

.real-input {
  border: none;
  outline: none;
  flex: 1;
  min-width: 120px;
  height: 28px;
}
</style>